<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="门店指标"> </pageTitle>
    <basicList ref="table" :config="basicListconfig" @search="searchEvent">
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            style="width: 100%"
            row-key="id"
            resizable
            border
            :show-overflow-tooltip="true"
            :height="basicListconfig.height"
             @sort-change="sortChange"
          >
            <el-table-column width="180" prop="name"  fixed="left" label="门店名称" />
            <el-table-column width="180" prop="username" label="店长" />
            <el-table-column label="营业额" align="center">
                <el-table-column width="120"  label="指标" >
                  <template slot-scope="scope">
                      <el-input  size="small" v-model="scope.row.turnover_trade" placeholder="指标"></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="120"  label="占比">
                  <template slot-scope="scope">
                      <div style="display: flex;" >
                        <el-input  size="small" v-model="scope.row.turnover_ratio" placeholder="占比"></el-input>
                        <span style="margin-top: 5px; margin-left: 5px;">%</span>
                      </div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="订单量" align="center">
                <el-table-column
                  width="120"
                  label="指标">
                  <template slot-scope="scope">
                      <el-input  size="small" v-model="scope.row.order_trade" placeholder="指标"></el-input>
                    </template>
                  </el-table-column>
                <el-table-column
                  width="120"
                  label="占比">
                    <template slot-scope="scope">
                      <div style="display: flex;" >
                        <el-input  size="small" v-model="scope.row.order_ratio" placeholder="占比"></el-input>
                        <span style="margin-top: 5px; margin-left: 5px;">%</span>
                      </div>
                    </template>
                  </el-table-column>
              </el-table-column>
            <el-table-column label="动销数" align="center">
              <el-table-column
                width="120"
                label="指标">
                <template slot-scope="scope">
                    <el-input  size="small" v-model="scope.row.sales_trade" placeholder="指标"></el-input>
                  </template>
                </el-table-column>
              <el-table-column
                width="120"
                label="占比">
                  <template slot-scope="scope">
                    <div style="display: flex;" >
                      <el-input  size="small" v-model="scope.row.sales_ratio" placeholder="占比"></el-input>
                      <span style="margin-top: 5px; margin-left: 5px;">%</span>
                    </div>
                  </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="毛利" align="center">
              <el-table-column
                width="120"
                label="指标">
                <template slot-scope="scope">
                    <el-input  size="small" v-model="scope.row.def_money_trade" placeholder="指标"></el-input>
                  </template>
                </el-table-column>
              <el-table-column
                width="120"
                label="占比">
                  <template slot-scope="scope">
                     <div style="display: flex;" >
                      <el-input  size="small" v-model="scope.row.def_money_ratio" placeholder="占比"></el-input>
                      <span style="margin-top: 5px; margin-left: 5px;">%</span>
                     </div>
                  </template>
                </el-table-column>
            </el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope" >
              <div style="display: flex; align-items: center">
                <template v-if="hasPermission('指标-指标管理-编辑')">
                  <div
                    class="button button_modify"
                    @click="editButton(scope.row,scope.$index)"
                  >
                    <i class="iconfont icon-bianji"></i> 更新
                  </div>
                </template>
              </div>
            </template>
          </el-table-column>
          </el-table>
          <div class="table_footer" v-if="basicListconfig.isPage">
            <p class="table_footer_total">
              共{{ basicListconfig.total }}项数据
            </p>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </basicList>
  </div>
</template>

<script>
const defaultParameters = {
    page: 1,
    limit: 10
  };
import { gettradelist, getshoplist,tradeUp,tradeAdd} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
import { mapGetters } from "vuex";
export default {
  name: "tradeManagement",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,
      showColumn:true,
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        //height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      storeList: [],
      summarizeData: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.obtainDataSource();
    // this.searchEvent({
    //   shop_id: JSON.parse(getRoles()).shop_id,
    // });
    this.getlist();
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    editButton(data,index){
      console.log(this.basicListconfig.data[index].id===null)
      if(this.basicListconfig.data[index].id>0){
        tradeUp({
          comp_id: this.compId,
          shop_id: data.shop_id,
          turnover_trade: data.turnover_trade,
          turnover_ratio: data.turnover_ratio,
          order_trade: data.order_trade,
          order_ratio: data.order_ratio,
          sales_trade: data.sales_trade,
          sales_ratio: data.sales_ratio,
          def_money_trade: data.def_money_trade,
          def_money_ratio: data.def_money_ratio,
          id:this.basicListconfig.data[index].id
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.$emit("close", 1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }else{
        tradeAdd({
          comp_id: this.compId,
          shop_id: data.shop_id,
          turnover_trade: data.turnover_trade,
          turnover_ratio: data.turnover_ratio,
          order_trade: data.order_trade,
          order_ratio: data.order_ratio,
          sales_trade: data.sales_trade,
          sales_ratio: data.sales_ratio,
          def_money_trade: data.def_money_trade,
          def_money_ratio: data.def_money_ratio,
          id:this.basicListconfig.data[index].id
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.$emit("close", 1);
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }

    },

   sortChange(data) {
     this.basicListconfig.searchParameters.page = 1;
     this.basicListconfig.searchParameters.order_column = data.prop;
     this.basicListconfig.searchParameters.order_up =data.order;
    // data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
     this.getlist();
   },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      gettradelist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.data;
          //this.showColumn=this.basicListconfig.data[0].shop_id==0?false:true;
          console.log(res.count);
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
        obtainDataSource() {
          getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
            (res) => {
              if (res.code == 1) {
                this.basicListconfig.search.map((item) => {
                  if (item.key == "shop_id") {
                    item.options = res.data.map((item) => {
                      return {
                        label: item.name,
                        value: item.id,
                      };
                    });
                  }
                  return item;
                });
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        },
      },
    };
</script>

<style  scoped>
.search_total {
  display: flex;
  line-height: 32px;
}
.search_total p {
  font-size: 16px;
  padding: 0 10px;
  font-weight: bold;
  color: #ffa100;
}
.search_total p span {
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/tradeManagement/index.vue